import React from "react";
import LeftSideBar from "../../Components/Common/LeftSideBar";
import Footer from "../../Components/Common/Footer";
import PageHeader from "../../Components/Common/PageHeader";
import TopBar from "../../Components/Common/TopBar";
import functions from "../../functions";
import ajax from "../../ajax";
import ActivityLoader from "../../Components/Common/ActivityLoader";

class SubProducts extends React.Component {
  state = {
    pdts: false,
    loading: false,
    shop_id: functions.shopId(),
    name: "",
    price: "",
  };

  componentDidMount() {
    this.listSubProducts();
  }

  listSubProducts = async () => {
    this.setState({ loading: true });
    const server_response = await ajax.listSubProducts(
      this.props.location.state.info.id
    );
    this.setState({ loading: false });
    if (server_response.status === "OK") {
      this.setState({
        pdts: server_response.details,
        message: server_response.message,
      });
    } else {
      this.setState({
        pdts: "404",
        message: server_response.message,
      });
    }
  };

  buttons = () => {
    return (
      <>
        {/* <button className="btn ripple btn-primary">
          <i className="fab fa-amazon-pay"></i> Recent Orders
        </button> */}
      </>
    );
  };

  deleteAdditive = (id) => {
    if (window.confirm("Are you sure you want to delete this Additive?")) {
      const server_response = ajax.deleteSubProduct(id);
      console.log(server_response);
      if (server_response) {
        this.setState(
          {
            pdts: false,
          },
          () => {
            this.listSubProducts();
          }
        );
      }
    }
  };

  onchangeName = (e) => {
    this.setState({ name: e.target.value });
  };
  onchangePrice = (e) => {
    this.setState({ price: e.target.value });
  };

  onsubmit = async () => {
    if (!this.state.name || !this.state.price) {
      this.setState({
        message: "Please fill in all the fields",
      });

      return;
    }
    const server_response = await ajax.createSubProduct(
      this.props.location.state.info.id,
      this.state.name,
      this.state.price
    );
    this.setState({ name: "", price: "" });
    if (server_response.status === "OK") {
      this.setState(
        {
          message: server_response.message,
          pdts: false,
          category: "",
        },
        () => this.listSubProducts()
      );
    }
  };
  render() {
    const { pdts, name, price } = this.state;

    return (
      <div classNmae="page">
        <LeftSideBar />
        <div
          className="main-content side-content pt-0"
          onClick={functions.closeSystemDrawer}
        >
          <TopBar />
          <div className="container-fluid">
            <PageHeader
              title="Sub Products"
              previousPageTitle="Dashboard"
              buttons={<this.buttons />}
            />
            <div className="row mb-5">
              <div className="col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-3"> Sub Products</h6>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#No</th>
                            <th>Sub product Name</th>
                            <th>Sub product Price</th>
                            <th>delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pdts &&
                            pdts !== "404" &&
                            pdts.map((pdt, key) => (
                              <tr>
                                <td>{key + 1}</td>
                                <td>{pdt["name"]}</td>
                                <td>{pdt["price"]}</td>

                                <td className="text-danger">
                                  {" "}
                                  <i
                                    className="fas fa-trash fa-lg"
                                    onClick={() =>
                                      this.deleteAdditive(pdt["id"])
                                    }
                                  ></i>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {pdts && pdts === "404" && (
                    <h4 className=" text-danger mt-5 ml-5">
                      No Additive Found!!!!
                    </h4>
                  )}
                  {!pdts && <ActivityLoader />}
                </div>
              </div>

              <div className="col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-3"> Add Sub Product</h6>
                    </div>

                    <div>
                      <div className="form-group">
                        <label className="">Sub Product Name</label>
                        <input
                          className="form-control"
                          required=""
                          type="text"
                          value={name}
                          onChange={this.onchangeName}
                        />
                      </div>
                      <div className="form-group">
                        <label className="">Sub Product Price</label>
                        <input
                          className="form-control"
                          required=""
                          type="text"
                          value={price}
                          onChange={this.onchangePrice}
                        />
                      </div>

                      <button
                        onClick={this.onsubmit}
                        className="btn ripple btn-main-primary btn-block"
                      >
                        Add Sub Product
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            width: "100%",
            textAlign: "center",
            bottom: "0px",
          }}
        >
          <Footer />
        </div>
      </div>
    );
  }
}

export default SubProducts;
